import React, { useState, useContext, useEffect } from "react";
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap";
import "./EquipmentAllType.css";
import { useNavigate, useParams } from "react-router-dom";
import { FaMoneyBill } from "react-icons/fa6";
import { EquipmentList } from "../../env/action";
import { UserContext } from "../../context/UserContext";

const EquipmentAllType = () => {
  const navigate = useNavigate();
  const { subservice_id, vendor_id } = useParams();
  const { selectedCartItems, setSelectedCartItems } = useContext(UserContext);
  const [equipments, setEquipmentDetails] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [expanded, setExpanded] = useState({});

  const getShortDescription = (text = "", limit = 5) => {
    const words = text.split(" ");
    if (words.length <= limit) return text;
    return words.slice(0, limit).join(" ") + "...";
  };

  const toggleDescription = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // ✅ Fetch Equipment List
  useEffect(() => {
    setLoading(true);
    const params = { vendor_id: vendor_id };
    EquipmentList(params, (res) => {
      if (res?.status === 1) {
        setEquipmentDetails(res.data);

        // Restore quantities from cart if already added
        if (selectedCartItems?.length > 0) {
          const initialQuantities = {};
          selectedCartItems.forEach((item) => {
            initialQuantities[item.id] = item.quantity;
          });
          setQuantities(initialQuantities);
        }
      }
      setLoading(false);
    });
  }, []);

  // ✅ Filter equipments by search
  const filteredEquipments = equipments.filter((item) =>
    item.equipment_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // ✅ Increment / Decrement
  const handleIncrement = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const handleDecrement = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: prev[id] > 0 ? prev[id] - 1 : 0,
    }));
  };

  // ✅ Add to Cart logic
  const handleAddToCart = (equipment) => {
    const quantity = quantities[equipment.id] || 0;
    if (quantity === 0) {
      alert("Please select at least 1 quantity before adding to cart");
      return;
    }

    // ensure selectedCartItems is always array
    const currentCart = Array.isArray(selectedCartItems)
      ? [...selectedCartItems]
      : [];

    const existingItemIndex = currentCart.findIndex((item) => item.id === equipment.id);

    if (existingItemIndex >= 0) {
      if (currentCart[existingItemIndex].quantity !== quantity) {
        currentCart[existingItemIndex].quantity = quantity;
      }
    } else {
      currentCart.push({
        vendor_id: equipment.vendor_id,
        id: equipment.id,
        equipment_name: equipment.equipment_name,
        price: equipment.price,
        image: equipment.image,
        quantity,
      });
    }

    setSelectedCartItems(currentCart);
    localStorage.setItem("equipmentCartItems", JSON.stringify(currentCart));
    navigate(`/equipment/Addtocart/${subservice_id}`, { state: { currentCart } });

  };

  const handleNavigateToCart = () => {
    navigate(`/equipment/Addtocart/${subservice_id}`);
  };

  return (
    <div className="equipment-all-type-wrapper">
      <Container>
        {/* 🔍 Search Bar */}
        <Row className="mb-3">
          <Col md={12} className="my-2">
            <Form.Control
              type="text"
              placeholder="Search Medical Equipments"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Col>
        </Row>

        <div className="row mb-4">
          <h4>Medical Equipment</h4>
        </div>
      </Container>

      {/* 🏥 Equipment Cards */}
      <Container>
        <div className="row g-4">
          {loading ? (
            <p>Loading...</p>
          ) : filteredEquipments.length === 0 ? (
            <p>No equipments found.</p>
          ) : (
            filteredEquipments.map((equipment) => (
              <div className="col-12 col-sm-6 col-lg-3" key={equipment.id}>
                <Card className="rounded-3 shadow-sm" style={{ width: "100%", height: "auto" }}>
                  <Card.Img
                    variant="top"
                    src={equipment.image}
                    className="equipimg"
                  />
                  <Card.Body>
                    <Card.Title className="fw-bolder fs-6">{equipment.equipment_name}</Card.Title>

                    <Card.Text className="text-muted" style={{ fontSize: "12px" }}>
                      {expanded[equipment.id]
                        ? equipment.description
                        : getShortDescription(equipment.description, 2)}

                      {equipment.description &&
                        equipment.description.split(" ").length > 2 && (
                          <span
                            onClick={() => toggleDescription(equipment.id)}
                            className="text-primary ms-1"
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                          >
                            {expanded[equipment.id] ? "View Less" : "View More"}
                          </span>
                        )}
                    </Card.Text>

                    {/* PRICE + COUNTER */}
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div className="d-flex align-items-center">
                        <FaMoneyBill className="me-2 text-success" />
                        <Card.Text className="mb-0 fw-bolder">
                          ₹{equipment.price}
                        </Card.Text>
                      </div>

                      {/* Quantity Counter */}
                      <div className="d-flex align-items-center countr">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="px-2 py-1 fw-bold"
                          onClick={() => handleDecrement(equipment.id)}
                        >
                          –
                        </Button>
                        <span className="mx-2 fw-bold fs-6">
                          {quantities[equipment.id] || 0}
                        </span>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="px-2 py-1 fw-bold"
                          onClick={() => handleIncrement(equipment.id)}
                        >
                          +
                        </Button>
                      </div>
                    </div>

                    {/* Add to Cart */}
                    <button
                      className="btn btn-primary w-100 border my-2"
                      style={{ fontSize: "13px" }}
                      onClick={() => handleAddToCart(equipment)}
                    >
                      Add to Cart
                    </button>

                    {/* Go to Cart */}
                    <button
                      className="btn btn-outline-dark w-100 border"
                      style={{ fontSize: "13px" }}
                      onClick={handleNavigateToCart}
                    >
                      View Cart
                    </button>
                  </Card.Body>
                </Card>
              </div>
            ))
          )}
        </div>
      </Container>
    </div>
  );
};

export default EquipmentAllType;
